import { IValidApp } from '@/interfaces/IValidApps';

export enum Apps {
    CASHOUT = 'CASHOUT',
    REWARDTIME = 'REWARDTIME',
    REWARDHERO = 'REWARDHERO',
    EASYREWARDS = 'EASYREWARDS',
    BOUNTYHUNTER = 'BOUNTYHUNTER',
    SURVEYPIRATE = 'SURVEYPIRATE',
}

export enum AppCodes {
    CASHOUT = 'CO',
    REWARDTIME = 'RT',
    REWARDHERO = 'RH',
    EASYREWARDS = 'ER',
    BOUNTYHUNTER = 'BH',
    SURVEYPIRATE = 'SP',
}

export enum AppDomains {
    REWARDTIME = 'rewardtime.app',
    REWARDHERO = 'rewardhero.app',
    CASHOUT = 'cashoutrewards.app',
    EASYREWARDS = 'easyrewards.app',
    SURVEYPIRATE = 'surveypirate.app',
    BOUNTYHUNTER = 'bountyhunterapp.co',
}
export enum AppNames {
    CASHOUT = 'CashOut',
    REWARDTIME = 'Reward Time',
    REWARDHERO = 'Reward Hero',
    EASYREWARDS = 'Easy Rewards',
    BOUNTYHUNTER = 'Bounty Hunter',
    SURVEYPIRATE = 'Survey Pirate',
}

export const AppsData: { [key: string]: IValidApp } = {
    [Apps.CASHOUT]: { name: AppNames.CASHOUT, appCode: AppCodes.CASHOUT, domain: AppDomains.CASHOUT, playStoreLink:'https://play.google.com/store/apps/details?id=co.bountyhunterapp' },
    [Apps.SURVEYPIRATE]: { name: AppNames.SURVEYPIRATE, appCode: AppCodes.SURVEYPIRATE, domain: AppDomains.SURVEYPIRATE, playStoreLink:'https://play.google.com/store/search?q=survey+pirate' },
    [Apps.REWARDHERO]: { name: AppNames.REWARDHERO, appCode: AppCodes.REWARDHERO, domain: AppDomains.REWARDHERO, playStoreLink:'https://play.google.com/store/apps/details?id=app.rewardhero'  },
    [Apps.REWARDTIME]: { name: AppNames.REWARDTIME, appCode: AppCodes.REWARDTIME, domain: AppDomains.REWARDTIME, playStoreLink:'https://play.google.com/store/apps/details?id=app.rewardtime'  },
    [Apps.BOUNTYHUNTER]: { name: AppNames.BOUNTYHUNTER, appCode: AppCodes.BOUNTYHUNTER, domain: AppDomains.BOUNTYHUNTER, playStoreLink:'https://play.google.com/store/apps/details?id=co.bountyhunterapp' },
    [Apps.EASYREWARDS]: { name: AppNames.EASYREWARDS, appCode: AppCodes.EASYREWARDS, domain: AppDomains.EASYREWARDS, playStoreLink:'https://play.google.com/store/apps/details?id=com.taplane.easyrewards'  },
}